import React, { useRef, useState } from 'react';
import axios from 'axios';
import config from '../../config';
import './css/admin.css';

const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('ru-RU');
};

const getStatusText = (status) => {
    if (!status) return 'Не указан';
    return typeof status === 'object' ? status.statusText || status._id || 'Не указан' : status;
};

const TrackSearch = () => {
    const [query, setQuery] = useState('');
    const [track, setTrack] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const searchTrack = async () => {
        const value = query.trim();
        if (!value) {
            setError('Введите трек-код или телефон клиента');
            inputRef.current?.focus();
            return;
        }

        setLoading(true);
        setError('');
        setTrack(null);

        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${config.apiUrl}/api/track/tracks`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { search: value, page: 1, limit: 1, sortByDate: 'latest' }
            });
            const result = response.data?.tracks?.[0];
            if (!result) {
                setError('Трек не найден');
                return;
            }
            setTrack(result);
        } catch (requestError) {
            console.error('Ошибка точечного поиска трека:', requestError);
            setError(requestError.response?.data?.message || 'Не удалось выполнить поиск');
        } finally {
            setLoading(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') searchTrack();
    };

    const history = Array.isArray(track?.history) ? [...track.history].reverse() : [];

    return (
        <div className="mainAdmin">
            <div className="users-container track-search-page">
                <h2>Точечный поиск трека</h2>
                <p className="track-search-description">Найдите посылку по трек-коду или номеру телефона клиента.</p>
                <div className="track-search-form">
                    <input
                        ref={inputRef}
                        className="searchInput"
                        value={query}
                        onChange={(event) => setQuery(event.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Трек-код или телефон"
                        aria-label="Трек-код или телефон"
                    />
                    <button className="filter-point filter-point-active" onClick={searchTrack} disabled={loading}>
                        {loading ? 'Поиск...' : 'Найти'}
                    </button>
                </div>

                {error && <div className="track-search-error">{error}</div>}

                {track && (
                    <section className="track-search-result">
                        <div className="track-search-summary">
                            <div><span>Трек-код</span><strong>{track.track}</strong></div>
                            <div><span>Клиент</span><strong>{track.user || 'Не привязан'}</strong></div>
                            <div><span>Текущий статус</span><strong>{getStatusText(track.status)}</strong></div>
                            <div><span>Обновлен</span><strong>{formatDate(track.updatedAt)}</strong></div>
                        </div>
                        <h3>История статусов</h3>
                        {history.length ? (
                            <div className="track-search-history">
                                {history.map((item) => (
                                    <div className="track-search-history-item" key={item._id || `${item.date}-${item.status}`}>
                                        <strong>{getStatusText(item.status)}</strong>
                                        <span>{formatDate(item.date)}</span>
                                    </div>
                                ))}
                            </div>
                        ) : <p>История статусов отсутствует.</p>}
                    </section>
                )}
            </div>
        </div>
    );
};

export default TrackSearch;
